import { createContext, FC, ReactNode, useCallback, useContext } from 'react'
import { useTableStore } from './table.store'

type Pagination = {
  page?: number
  limit?: number
}

interface TableContextData {
  setPagination: (pagination: Pagination) => void
  pagination: Pagination
  handlePageChange: (page: number) => void
  handlePageSizeChange: (limit: number) => void
}

interface TableProviderProps {
  children?: ReactNode
  limit?: number
  page?: number
}

export const TableContext = createContext<TableContextData>(
  {} as TableContextData
)

export const TableProvider: FC<TableProviderProps> = ({ children }) => {
  // const [pagination, setPagination] = useState<Pagination>({
  //   page,
  //   limit
  // })

  const pagination = useTableStore.usePagination()
  const _setPagination = useTableStore.useSetPagination()

  const handlePageChange = useCallback(
    (page: number) => {
      _setPagination({
        ...pagination,
        page
      })
    },
    [pagination, _setPagination]
  )

  const handlePageSizeChange = useCallback(
    (limit: number) => {
      _setPagination({
        ...pagination,
        limit
      })
    },
    [pagination, _setPagination]
  )

  const setPagination = useCallback(
    (p: Pagination) => {
      _setPagination({ ...pagination, ...p })
    },
    [pagination, _setPagination]
  )

  return (
    <TableContext.Provider
      value={{
        setPagination,
        pagination,
        handlePageSizeChange,
        handlePageChange
      }}
    >
      {children}
    </TableContext.Provider>
  )
}

export function useTableContext() {
  return useContext(TableContext)
}
